import { render, staticRenderFns } from "./DayOfWeek.vue?vue&type=template&id=bd66c874"
import script from "./DayOfWeek.vue?vue&type=script&lang=js"
export * from "./DayOfWeek.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bd66c874')) {
      api.createRecord('bd66c874', component.options)
    } else {
      api.reload('bd66c874', component.options)
    }
    module.hot.accept("./DayOfWeek.vue?vue&type=template&id=bd66c874", function () {
      api.rerender('bd66c874', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/select/DayOfWeek.vue"
export default component.exports